import { v4 as uuid } from "uuid";

import { EntityTypes } from "../../EntityTypes";
import { ITagResource } from "../../tags";
import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValueAsIRI, RelationalValue } from "../../utils/filters";
import { ICategoryResource } from "../types";

export type ICategoryCreateMutationParameters = Pick<ICategoryResource, "title"> & {
    uuid?: string;
    tags: RelationalValue<ITagResource>[];
};

export type ICategoryCreateMutationResult = ICategoryResource;

export const categoryCreateMutation: IApiMutationFunction<ICategoryCreateMutationParameters> = data => {
    return {
        method: "POST",
        url: "/categories",
        data: {
            ...data,
            tags: data.tags.map(tag => mapRelationalValueAsIRI(EntityTypes.TAG, tag)),
            uuid: data.uuid ?? uuid(),
        },
    };
};

export const useCategoryCreateMutation = createApiMutationHook<
    ICategoryCreateMutationParameters,
    ICategoryCreateMutationResult
>(categoryCreateMutation);
